export class VendorBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    name: string;
    companyName: string;
    email: string;
    phone: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    statusLid: string;
    statusLovName: string;
    taxId: string;
    agencyId: string;
}
export class GetListBO {
    orderColumn: string = "name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: string;
    field: string = "name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}
export class WhereCondition {
    field: string = "name";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class functionpermission {
    vendorcreate: boolean = true
    vendorupdate: boolean = true

    vendordelete: boolean = true

}